module.exports = __webpack_public_path__ + "img/cf247-logo.a6136f99.svg";